module.exports = __webpack_public_path__ + "img/icon_order-book-S.960501d7.svg";